import { NodeParamsConfig } from "../utils/params/ParamsConfig";
import { UniformsTransparencyParamConfig, UniformsTransparencyController } from "./utils/UniformsTransparencyController";
import { AdvancedCommonController, AdvancedCommonParamConfig } from "./utils/AdvancedCommonController";
import { MapParamConfig, TextureMapController } from "./utils/TextureMapController";
import { AlphaMapParamConfig, TextureAlphaMapController } from "./utils/TextureAlphaMapController";
import { BaseBuilderParamConfig, TypedBuilderMatNode } from "./_BaseBuilder";
import { AssemblerName } from "../../poly/registers/assemblers/_BaseRegister";
import { Poly } from "../../Poly";
import { FogParamConfig, FogController } from "./utils/UniformsFogController";
import { WireframeController, WireframeParamConfig } from "./utils/WireframeShaderMaterialController";
import { TextureAOMapController, AOMapParamConfig } from "./utils/TextureAOMapController";
import { TextureEnvMapSimpleController, EnvMapSimpleParamConfig } from "./utils/TextureEnvMapSimpleController";
import { TextureLightMapController, LightMapParamConfig } from "./utils/TextureLightMapController";
import { TextureEmissiveMapController, EmissiveMapParamConfig } from "./utils/TextureEmissiveMapController";
import { PCSSController, PCSSParamConfig } from "./utils/PCSSController";
import { DefaultFolderParamConfig } from "./utils/DefaultFolder";
import { TexturesFolderParamConfig } from "./utils/TexturesFolder";
import { AdvancedFolderParamConfig } from "./utils/AdvancedFolder";
class MeshLambertBuilderMatParamsConfig extends PCSSParamConfig(FogParamConfig(WireframeParamConfig(AdvancedCommonParamConfig(BaseBuilderParamConfig(AdvancedFolderParamConfig(LightMapParamConfig(EnvMapSimpleParamConfig(EmissiveMapParamConfig(AOMapParamConfig(AlphaMapParamConfig(MapParamConfig(TexturesFolderParamConfig(UniformsTransparencyParamConfig(DefaultFolderParamConfig(NodeParamsConfig))))))))))))))) {
}
const ParamsConfig = new MeshLambertBuilderMatParamsConfig();
export class MeshLambertBuilderMatNode extends TypedBuilderMatNode {
  constructor() {
    super(...arguments);
    this.paramsConfig = ParamsConfig;
    this.controllers = {
      advancedCommon: new AdvancedCommonController(this),
      alphaMap: new TextureAlphaMapController(this),
      aoMap: new TextureAOMapController(this),
      emissiveMap: new TextureEmissiveMapController(this),
      envMap: new TextureEnvMapSimpleController(this),
      lightMap: new TextureLightMapController(this),
      map: new TextureMapController(this),
      PCSS: new PCSSController(this)
    };
    this.controllerNames = Object.keys(this.controllers);
  }
  static type() {
    return "meshLambertBuilder";
  }
  usedAssembler() {
    return AssemblerName.GL_MESH_LAMBERT;
  }
  _createAssemblerController() {
    return Poly.assemblersRegister.assembler(this, this.usedAssembler());
  }
  initializeNode() {
    this.params.onParamsCreated("init controllers", () => {
      for (let controllerName of this.controllerNames) {
        this.controllers[controllerName].initializeNode();
      }
    });
  }
  async cook() {
    for (let controllerName of this.controllerNames) {
      this.controllers[controllerName].update();
    }
    UniformsTransparencyController.update(this);
    FogController.update(this);
    WireframeController.update(this);
    this.compileIfRequired();
    this.setMaterial(this.material);
  }
}
